import { computed, effect, inject, Injectable } from '@angular/core'
import { Dialog } from '@angular/cdk/dialog'

import { getModalComponent } from '@notifications/data/modals'
import { Notification } from '@notifications/models/notifications'
import { NotificationsService } from './notifications.service'

@Injectable({
  providedIn: 'root'
})
export class NotificationModalService {
  private dialog = inject(Dialog)
  notificationsService = inject(NotificationsService)

  notificationToShow = computed(() => {
    const notifications = this.notificationsService.notifications()

    return notifications.find(n => {
      return n.auto_show && n.status === 'show'
    })
  })

  constructor() {
    effect(() => {
      const notificationToShow = this.notificationToShow()
      if (!notificationToShow) return

      this.openNotificationModal(notificationToShow)
    })
  }

  async openNotificationModal(notification: Notification, disableClose = true) {
    const component = await getModalComponent(notification)

    if (component) {
      this.dialog.open(component, {
        autoFocus: '',
        disableClose,
        data: notification,
        panelClass: 'notification-modal'
      })
    }
  }
}
